import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import { resumeApplicationAction } from 'actions/workflow';
import useWorkflowGuard from 'hooks/useWorkflowGuard';
import Spinner from 'components/Spinner';
import GeneralError from 'components/GeneralError';

const CreditFreeze = ({ navigate, searchParams, dispatch }) => {
  useWorkflowGuard(searchParams, navigate);
  const [isLoading, setIsLoading] = useState(false);
  const [generalError, setGeneralError] = useState(null);

  const resumeApplication = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setGeneralError(null);

    dispatch(resumeApplicationAction({
      key: searchParams.get('key'),
      activity: 'continuefromcreditfreeze',
      success: (res) => {
        setIsLoading(false);
        const route = get(res, 'data.url') || get(res, 'state.url');
        if (route) {
          navigate(route);
        }
      },
      fail: (error) => {
        setIsLoading(false);
        setGeneralError(get(error, 'data.failure.errors.0') || { message: 'An error occurred, please try again.' });
      },
    }));
  };

  if (isLoading) {
    return <Spinner size={8} className="mx-auto mt-12 mb-10" color="blue-400" />;
  }

  return (
    <div className="flex flex-col items-center text-center mb-8">
      <p className="text-sm md:text-base text-gray-600">
        The following actions are needed so that a <br />decision can be made on your application:
      </p>

      <div className="my-6 text-left bg-blue-50 border border-slate-200 rounded px-4 py-6">
        <div className="flex items-center gap-3 mb-6">
          <span
            className="relative bg-sky-100 shrink-0 w-12 h-12 rounded-full flex items-center justify-center font-bold text-blue-500 after:absolute after:w-[2px] after:h-full after:-translate-x/4 after:top-8 after:left-2/4 after:bg-sky-100"
          >1</span>
          <p className="leading-tight">
            To remove the freeze from your credit report, please visit the <a href="https://ciam.tui.transunion.com/realms/TransUnion/protocol/openid-connect/auth?response_type=code&redirect_uri=https%3A%2F%2Fservice.transunion.com%2Fdss%2Flanding.page&state=3k0iBRdkaksCWlYxXvXtuXqazhi53Su8q0tCuEOIhgg&client_id=Phoenix&scope=openid&redirectedFromSite=DSS:Tue%20Sep%2016%202025%2018:02:52%20GMT-0400%20(Eastern%20Daylight%20Time)" target="_blank" className="font-semibold text-blue-500">TransUnion Service Center</a> or call <a href="tel:+18889098872" className="font-semibold text-blue-500">TransUnion at <span className="whitespace-nowrap">888-909-8872</span></a>
          </p>
        </div>
        <div className="flex items-center gap-3">
          <span className="relative bg-sky-100 shrink-0 w-12 h-12 rounded-full flex items-center justify-center font-bold text-blue-500">2</span>
          <p className="leading-tight">
            After the removal of the credit freeze, please click on this <a className="text-blue-500 font-semibold underline" href="#" onClick={resumeApplication}>link</a> to continue your application.
          </p>
        </div>
      </div>

      <GeneralError error={generalError} className="w-full text-left" />

      <hr className="w-full mb-6" />

      <p className="text-sm text-slate-600 px-0 md:px-6">
        You must complete the above actions within <span className="font-semibold whitespace-nowrap">30 days</span>; otherwise, we will be unable to proceed with the credit application.
      </p>
    </div>
  );
};

CreditFreeze.propTypes = {
  navigate: PropTypes.func.isRequired,
  searchParams: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default CreditFreeze;
